import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getCurrentMerchant } from 'core/MerchantFilter/selectors';
import {
  isSuperUser as isSuperUserSelector,
  getUser,
} from 'common/auth/selectors';

const useFullstoryIdentify = ({ merchantId, externalId, merchantName }) => {
  useEffect(() => {
    if (merchantId && externalId) {
      window.FS.identify(merchantId, {
        merchantName,
        userExternalId: externalId,
      });
    } else {
      window.FS.identify(false);
    }
    // If you touch this file you should fix this ignore statement
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [merchantId, externalId]);
};

const useControlFullstory = isSuperUser => {
  const shutdownFullstory = () => {
    if (window.FS) {
      window.FS.shutdown();
    }
  };
  const restartFullStory = () => {
    if (window.FS) {
      window.FS.restart();
    }
  };
  useEffect(() => {
    if (isSuperUser) {
      shutdownFullstory();
    } else {
      restartFullStory();
    }
  }, [isSuperUser]);
};

const FullStory = ({
  isSuperUser,
  currentMerchant: { merchantName, merchantId },
  currentUser: { externalId },
}) => {
  useEffect(() => {
    /* eslint-disable */
    window['_fs_debug'] = false;
    window['_fs_host'] = 'fullstory.com';
    window['_fs_org'] = 'FVWPP';
    window['_fs_namespace'] = 'FS';
    (function (m, n, e, t, l, o, g, y) {
      if (e in m) {
        if (m.console && m.console.log) {
          m.console.log(
            'FullStory namespace conflict. Please set window["_fs_namespace"].',
          );
        }
        return;
      }
      g = m[e] = function (a, b, s) {
        g.q ? g.q.push([a, b, s]) : g._api(a, b, s);
      };
      g.q = [];
      o = n.createElement(t);
      o.async = 1;
      o.src = 'https://' + _fs_host + '/s/fs.js';
      y = n.getElementsByTagName(t)[0];
      y.parentNode.insertBefore(o, y);
      g.identify = function (i, v, s) {
        g(l, { uid: i }, s);
        if (v) g(l, v, s);
      };
      g.setUserVars = function (v, s) {
        g(l, v, s);
      };
      g.event = function (i, v, s) {
        g('event', { n: i, p: v }, s);
      };
      g.shutdown = function () {
        g('rec', !1);
      };
      g.restart = function () {
        g('rec', !0);
      };
      g.consent = function (a) {
        g('consent', !arguments.length || a);
      };
      g.identifyAccount = function (i, v) {
        o = 'account';
        v = v || {};
        v.acctId = i;
        g(o, v);
      };
      g.clearUserCookie = function () {};
    })(window, document, window['_fs_namespace'], 'script', 'user');
    /* eslint-enable */
  }, []);
  useControlFullstory(isSuperUser);
  useFullstoryIdentify({ merchantId, externalId, merchantName });
  return null;
};

FullStory.propTypes = {
  currentMerchant: PropTypes.shape({}),
  currentUser: PropTypes.shape({
    externalId: PropTypes.string,
  }),
  isSuperUser: PropTypes.bool,
};

FullStory.defaultProps = {
  currentMerchant: {
    merchantId: '',
    merchantName: '',
  },
  currentUser: {
    externalId: '',
  },
  isSuperUser: false,
};

export default connect(state => ({
  currentMerchant: getCurrentMerchant(state),
  isSuperUser: isSuperUserSelector(state),
  currentUser: getUser(state),
}))(FullStory);
